"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = exports.ListItem = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _consts = require("./consts");
var _tailwind = require("../common/tailwind");
var _consts2 = require("../utils/layout/consts");
var _ListItem = _interopRequireDefault(require("./ListItem"));
exports.ListItem = _ListItem.default;
const sizeTokens = {
  [_consts.SIZES.SMALL]: "text-small leading-small [&_.orbit-list-item-icon>svg]:h-icon-small [&_.orbit-list-item-icon>svg]:w-icon-small",
  [_consts.SIZES.NORMAL]: "text-normal leading-normal [&_.orbit-list-item-icon>svg]:h-icon-medium [&_.orbit-list-item-icon>svg]:w-icon-medium [&_.orbit-list-item-label]:text-small",
  [_consts.SIZES.LARGE]: "text-large leading-large [&_.orbit-list-item-icon>svg]:h-icon-large [&_.orbit-list-item-icon>svg]:w-icon-large [&_.orbit-list-item-label]:text-normal"
};
const typeTokens = {
  [_consts.TYPES.PRIMARY]: "text-primary-foreground",
  [_consts.TYPES.SECONDARY]: "text-secondary-foreground"
};
const List = ({
  children,
  dataTest,
  id,
  size = _consts.SIZES.NORMAL,
  type = _consts.TYPES.PRIMARY,
  spacing = _consts2.SPACINGS.ONE_HUNDRED,
  spaceAfter
}) => {
  return /*#__PURE__*/React.createElement("ul", {
    "data-test": dataTest,
    id: id,
    className: (0, _clsx.default)("orbit-list font-base m-0 flex w-full list-none flex-col p-0", sizeTokens[size], typeTokens[type], spaceAfter != null && _tailwind.spaceAfterClasses[spaceAfter], spacing && (0, _tailwind.getSpacingClasses)(spacing))
  }, children);
};
var _default = exports.default = List;